import nanoid from "nanoid";
import { storePageviewVariant } from "src/services/event/pageviews/store-variant";

const prod = process.env.REACT_APP_RELEASE_STAGE === "production";
const dev = process.env.REACT_APP_RELEASE_STAGE === "development";

export default function trackPageviewVariant(data) {
  const pageviewGuid =
    window.sessionStorage.getItem("pageviewGuid") || nanoid();
  const pageviewVariantData = {
    pageview_guid: pageviewGuid,
    variant_id: data.variantId || "",
    coupon: data.coupon || "",
  };
  if (prod) {
    storePageviewVariant(pageviewVariantData);
  } else if (dev) {
    console.warn("page view", pageviewVariantData);
  }
}
